import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { render } from 'react-dom';
import { browserHistory, IndexRedirect, IndexRoute, Route, Router } from 'react-router';

import Application from './PublicPortal/Application';
import NotFound from './PublicPortal/NotFound';
import OrganizationPortal from './PublicPortal/OrganizationPortal';
import { ROOT_ELEMENT_SELECTOR } from './consts';
import DialogContextProvider from './contexts/DialogContext';
import ToastContextProvider from './contexts/ToastContext';
import ReleaseGroupList from './PublicPortal/OrganizationPortal/ReleaseGroupList';
import ReleaseGroup from './PublicPortal/OrganizationPortal/ReleaseGroup';
import { theme } from './theme/mui-theme';
import './styles/fossa.less';

const Portal = () => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <DialogContextProvider>
        <ToastContextProvider>
          <Router history={browserHistory}>
            {/* Please create route helpers for any routes in ./PublicPortal/helpers/routes.ts */}
            <Route path="/" component={Application}>
              <Route path="p/:slug" component={OrganizationPortal}>
                <IndexRedirect to="public" />
                <Route path=":visibility">
                  <IndexRoute component={ReleaseGroupList} />
                </Route>
                <Route path="release/:releaseGroupId">
                  <IndexRedirect to="latest" />
                  <Route path=":releaseId(/:viewType)" component={ReleaseGroup} />
                </Route>
              </Route>
              <Route path="*" component={NotFound} />
            </Route>
          </Router>
        </ToastContextProvider>
      </DialogContextProvider>
    </ThemeProvider>
  </StyledEngineProvider>
);

render(<Portal />, document.querySelector(ROOT_ELEMENT_SELECTOR));
